import { Type } from 'typebox';
import { Attachment } from '../reference/attachment.js';
import { createFallbackStringEnumCodec } from '../../utils/fallback-string-enum-codec.js';
export const Roles = {
    employee: 'Employee',
    locationAdmin: 'LocationAdmin',
    accountAdmin: 'AccountAdmin',
    appAdmin: 'AppAdmin',
    regionalAdmin: 'RegionaAdmin',
    teamMember: 'TeamMember',
    guardian: 'Guardian',
    child: 'Recipient',
    unknown: 'unknown'
};
export const Role = Type.Union([
    Type.Literal(Roles.employee),
    Type.Literal(Roles.locationAdmin),
    Type.Literal(Roles.accountAdmin),
    Type.Literal(Roles.appAdmin),
    Type.Literal(Roles.regionalAdmin),
    Type.Literal(Roles.teamMember),
    Type.Literal(Roles.guardian),
    Type.Literal(Roles.child),
    Type.Literal(Roles.unknown)
]);
export const RoleCodec = createFallbackStringEnumCodec(Roles, Roles.unknown);
export const AdminRoles = new Set([
    Roles.locationAdmin,
    Roles.accountAdmin,
    Roles.regionalAdmin
]);
export const EmployeeRoles = new Set([
    Roles.employee,
    Roles.teamMember,
    ...AdminRoles
]);
export const Person = Type.Object({
    key: Type.String({ minLength: 1 }),
    uid: Type.Optional(Type.String({ minLength: 1 })),
    firstName: Type.Optional(Type.String({ minLength: 1 })),
    lastName: Type.Optional(Type.String({ minLength: 1 })),
    displayName: Type.Optional(Type.String({ minLength: 1 })),
    nickname: Type.Optional(Type.String({ minLength: 1 })),
    roles: Type.Array(RoleCodec),
    language: Type.Optional(Type.String({ minLength: 1 })),
    email: Type.Optional(Type.String({ minLength: 1 })),
    mobileNumber: Type.Optional(Type.String({ minLength: 1 })),
    workNumber: Type.Optional(Type.String({ minLength: 1 })),
    homeNumber: Type.Optional(Type.String({ minLength: 1 })),
    note: Type.Optional(Type.String({ minLength: 1 })),
    pin: Type.Optional(Type.String({ minLength: 1 })),
    attachedImage: Type.Optional(Attachment),
    uniqueName: Type.Optional(Type.String({ minLength: 1 }))
});
